import React from 'react'
import { Link } from 'react-router-dom'
import * as TypeUtils from '../util/TypeUtils'

// navbar-dark bg-dark
// navbar-dark bg-primary
export default class Navbar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      pack: true,
    }
  }
  static getDerivedStateFromProps(nextProps, prevState) {

    return null
  }
  componentDidMount() {

  }
  render() {
    return (
      <nav
        className={`navbar navbar-expand-sm ${TypeUtils.isNonEmptyString(this.props.className)?this.props.className:'navbar-light bg-light'}`}
        style={this.props.style}
      >
        <a className="navbar-brand" href="">{this.props.name}</a>

        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <div className="navbar-nav">
            {
              Array.isArray(this.props.links)&&
              this.props.links.map((link,index)=>(
                <Link
                  key={index}
                  className={`nav-item nav-link ${this.state.pack===true?'active':''}`}
                  to={link.path}
                  onClick={()=>{
                    this.setState({pack:true})
                  }}
                >{link.name}</Link>
              ))
            }
          </div>
        </div>
      </nav>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Navbar.js